export default __webpack_public_path__ + "static/Gellix-Medium-15d86b2d4318202950f8ed2396e79e1f.ttf";